'use client';

import { useParams } from 'next/navigation';

import ButtonLink from '@/components/ui/ButtonLink';
import Text from '@/components/ui/Text';

const BlogCard = ({ article }: BlogCardProps) => {
  const { title, summary, slug, date, buttonText } = article;
  const { locale } = useParams<{ locale: string }>();

  return (
    <article className="relative h-full flex flex-col transition-transform duration-300 hover:-translate-y-1">
      <div className="flex flex-col flex-1">
        <Text as="p" variant="cardEyebrow" className="mb-3">
          {date}
        </Text>
        <Text as="h3" variant="cardTitle" className="mb-2">
          {title}
        </Text>
        <Text
          as="p"
          variant="paragraph"
          className="overflow-hidden [display:-webkit-box] [-webkit-line-clamp:3] [-webkit-box-orient:vertical]"
        >
          {summary}
        </Text>
        <div className="mt-auto desktop:pt-4">
          <ButtonLink
            href={`/${locale}/blog/${slug}`}
            variant="text"
            arrow
            className="after:absolute after:inset-0"
          >
            {buttonText}
            <span className="sr-only"> {title}</span>
          </ButtonLink>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;

export type Article = {
  title: string;
  date: string;
  summary: string;
  buttonText: string;
  slug: string;
};

type BlogCardProps = {
  article: Article;
};
